import { BoxProps, CSSObject } from '@chakra-ui/react';

export const wrapperProps: BoxProps = {
  h: '100%',
  minW: ['unset', null, '460px'],
  maxW: '100vw',
  display: 'flex',
  justifyContent: 'center',
  fontFamily: 'accent',
  sx: {
    'div:first-child': {
      color: 'red.500',
      display: 'flex',
      flexDir: 'column',
      fontSize: 'xs',
      fontWeight: 'bold',
      alignItems: 'flex-start',
      svg: {
        boxSize: '2.5',
        mr: '1',
      },
      '.chakra-link': {
        mb: '4',
        color: 'delta.500',
        textTransform: 'unset',
        fontSize: '2xs',
        fontFamily: 'body',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
      },
    },
  },
  bg: 'white',
  borderTop: ['2px', null, '0px'],
  borderColor: 'beta.300',
};

export const TextForgotPasswordSuccess: CSSObject = {
  color: 'beta.800',
  fontSize: 'sm',
  fontStyle: 'normal',
  fontWeight: 'semibold',
  fontFamily: 'body',
  mb: '2',
  '+ a': {
    display: 'none',
  },
};

export const linkLoginProps: CSSObject = {
  fontWeight: 'bold',
  color: 'beta.500',
  textTransform: 'uppercase',
  fontSize: 'xs',
};

export const ForgotPasswordButton: CSSObject = {
  fontSize: 'sm',
  fontWeight: 'normal',
  textTransform: 'uppercase',
};

export const Title: CSSObject = {
  color: 'beta.800',
  fontFamily: 'heading',
};
